import { m } from 'framer-motion';
import { LN1, Text3, styled, withStyle } from '@olxeu-jobs/ui';

export const Wrapper = styled('div', ({ $theme }) => ({
  display: 'flex',
  position: 'relative',
  gap: $theme.space[16],
  width: '100%',
}));

export const IndicatorMotion = styled(m.div, () => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
}));

export const CountableIndicator = styled('div', () => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  aspectRatio: '1',
  width: '48px',
}));

export const Header = styled('div', ({ $theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: $theme.space[16],
}));

export const Title = withStyle<typeof LN1, { $dim?: boolean }>(LN1, ({ $theme, $dim }) => ({
  opacity: $dim ? 0.5 : 1,
  transition: `opacity ${$theme.animation.duration[200]}`,
}));

export const Description = withStyle<typeof Text3, { $dim?: boolean }>(
  Text3,
  ({ $theme, $dim }) => ({
    opacity: $dim ? 0.5 : 1,
    transition: `opacity ${$theme.animation.duration[200]}`,
  }),
);

export const ContentMotion = styled(m.div, ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: $theme.space[8],
  [$theme.mediaQuery.md]: {
    gap: $theme.space[16],
  },
  [$theme.mediaQuery.lg]: {
    flexDirection: 'row',
    alignItems: 'center',
  },
}));

export const TextContent = styled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: $theme.space[8],
}));

export const Actions = styled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginRight: 'auto',
  marginLeft: 'auto',
  gap: $theme.space[16],
  [$theme.mediaQuery.sm]: {
    flexDirection: 'row',
    flexShrink: 0,
  },
  [$theme.mediaQuery.lg]: {
    marginRight: 0,
  },
}));
